import type { ReactElement } from "react";
import cx from "classnames";
import Link from "next/link";
import Text from "../../atoms/Text";
import * as s from "./styles";
import type { NavbarLink } from "./index";

export default function NavLink({
  activeRegex,
  href,
  icon,
  isExternal,
  label,
  id,
  rightSideIcon,
  color,
  variant,
}: NavbarLink): ReactElement | null {
  const regex = activeRegex ? new RegExp(activeRegex) : false;
  const isActive =
    (!isExternal && href && regex && regex.test(window.location.pathname)) ??
    false;
  const isDark = variant === "dark";

  if (!href) {
    return null;
  }

  if (isExternal) {
    return (
      <a
        href={href}
        className={cx(s.item, {
          [s.itemDark]: isDark,
          [s.itemSelected]: isActive,
        })}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={id}
        // data-intercom-target={id + "-intercom"}
      >
        {icon && <span>{icon}</span>}
        <Text weight="bold">{label}</Text>
      </a>
    );
  }

  return (
    <Link
      href={href}
      className={cx(s.item, {
        [s.itemSelected]: isActive,
        [s.itemDark]: isDark,
        [s.itemSelectedDark]: isDark && isActive,
      })}
      data-testid={id}
      // data-intercom-target={id + "-intercom"}
    >
      {icon && (
        <span className={isDark ? "text-neutral-200 active:text-white" : ""}>
          {icon}
        </span>
      )}
      <Text
        color={isDark ? (isActive ? "white" : "light") : color}
        weight="bold"
      >
        {label}
      </Text>
      {rightSideIcon && <span className="ml-auto">{rightSideIcon}</span>}
    </Link>
  );
}
